import { Loader2 } from 'lucide-react'
import { cn } from '../../../utils/cn'

interface AssessmentProgressProps {
  title?: string
  progress: number
  status?: string
  isComplete?: boolean
  className?: string
}

export function AssessmentProgress({
  title = 'Analyzing Result...',
  progress,
  status,
  isComplete = false,
  className,
}: AssessmentProgressProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center space-y-6 py-20',
        className
      )}
    >
      {/* Title */}
      <h2 className='text-2xl font-bold text-gray-900'>{title}</h2>

      {/* Progress Bar */}
      <div className='w-full max-w-2xl space-y-3'>
        <div className='relative h-2 w-full overflow-hidden rounded-full bg-gray-200'>
          <div
            className='h-full rounded-full bg-gray-900 transition-all duration-500 ease-out'
            style={{ width: `${progress}%` }}
          />
        </div>

        {/* Progress Info */}
        <div className='flex items-center justify-between text-sm'>
          <span
            className={cn(
              'font-medium',
              isComplete ? 'text-green-600' : 'text-gray-600'
            )}
          >
            {status || (isComplete ? 'Completed' : 'Few seconds left')}
          </span>
          <span className='font-semibold text-gray-900'>{progress}%</span>
        </div>
      </div>

      {/* Loading Spinner (only show when not complete) */}
      {!isComplete && (
        <Loader2 className='h-8 w-8 animate-spin text-gray-400' />
      )}
    </div>
  )
}
